import { graphql, Link, StaticQuery } from "gatsby";
import React from "react";
import Img from "gatsby-image";
import { Col, Row } from "react-bootstrap";
import styled from "styled-components";

const POST_IMAGE_QUERY = graphql`
  query PostImageQuery {
    allMarkdownRemark(
      sort: { order: DESC, fields: frontmatter___date }
      filter: { fields: { sourceInstanceName: { eq: "articles" } } }
    ) {
      edges {
        node {
          frontmatter {
            slug
            featuredImage {
              childImageSharp {
                fluid(maxWidth: 500) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            title
            sample
          }
        }
      }
    }
  }
`;

const Title = styled.div`
  margin: 48px 0 28px;
  font-size: 24px;
  font-weight: 600;
  line-height: 1.33;
  color: #242d41;
`;

const RowWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  position: relative;
`;

const TitleWrapper = styled.div`
  width: 50%;
  @media (max-width: 821px) {
    width: 82%;
  }
  @media (max-width: 451px) {
    width: 100%;
  }
`;

const StyledCard = styled.div`
  @media (max-width: 451px) {
    margin-bottom: 28px;
  }
`;

const StyledRow = styled(Row)`
  display: flex;
  justify-content: center;
  width: 100%;
`;

const StyledImg = styled(Img)`
  margin-bottom: 12px;
  border-radius: 4px;
`;

const CardTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  line-height: 1.25;
  color: #242d41;
  margin-bottom: 8px;
`;

const CardText = styled.div`
  line-height: 1.57;
  color: rgba(36, 45, 65, 0.9);
  -webkit-line-clamp: 4;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const YouMayAlsoLike = ({ currentUrl }) => {
  const displayCard = (edge) => {
    return (
      <Link to={edge?.node?.frontmatter?.slug}>
        <StyledCard>
          <StyledImg
            fluid={
              edge?.node?.frontmatter?.featuredImage?.childImageSharp?.fluid
            }
          />
          <CardTitle>{edge?.node?.frontmatter?.title}</CardTitle>
          <CardText>{edge?.node?.frontmatter?.sample}</CardText>
        </StyledCard>
      </Link>
    );
  };
  return (
    <>
      <StaticQuery
        query={POST_IMAGE_QUERY}
        render={({ allMarkdownRemark }) => {
          return (
            <RowWrapper>
              <TitleWrapper>
                <Title>You may also like</Title>
                <StyledRow>
                  {allMarkdownRemark.edges
                    .filter(
                      (item) => currentUrl !== item?.node?.frontmatter?.slug
                    )
                    .map((edge, index) => {
                      if (index > 2) return null;
                      return (
                        <Col key={edge?.node?.frontmatter?.slug} md={4}>
                          {displayCard(edge)}
                        </Col>
                      );
                    })}
                </StyledRow>
              </TitleWrapper>
            </RowWrapper>
          );
        }}
      />
    </>
  );
};

export default YouMayAlsoLike;
